import PropTypes from "prop-types";
import React from "react";
import { Button, Col, FormControl, Row } from "react-bootstrap";
import ParamFormUtils from "ui/parameter-form/utils";

import { FormInput } from "./form-input";

class CustomParamField extends React.PureComponent {
  static get propTypes() {
    return {
      field: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      hasDuplicate: PropTypes.func.isRequired,
      legacyParams: PropTypes.instanceOf(Set),
      onRemove: PropTypes.func.isRequired,
      readOnly: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      readOnly: false,
    };
  }

  constructor() {
    super();

    this._onKeyChange = this._onKeyChange.bind(this);
    this._onValChange = this._onValChange.bind(this);
  }

  _onKeyChange(e) {
    const { field, handleChange, hasDuplicate, legacyParams } = this.props;
    const { value } = field;
    const k = e.target.value;

    const nextValue = {
      ...value,
      k,
      isLegacy: legacyParams.has(k),
      isDuplicate: hasDuplicate(k),
    };
    nextValue.errors = ParamFormUtils.getErrorMsg(nextValue);

    handleChange(nextValue);
  }

  _onValChange(e) {
    const { handleChange, field } = this.props;
    const { value } = field;

    const nextValue = { ...value, v: e.target.value };
    handleChange(nextValue);
  }

  render() {
    const { field, onRemove, readOnly } = this.props;
    const { k, v, hasOverride, isOverriding } = field.value;

    const removeBtn = (
      <Button
        data-qa="Remove.Button"
        variant="danger"
        disabled={readOnly}
        onClick={onRemove}
        title="Click to unset this parameter."
      >
        <i className="fa fa-minus" />
      </Button>
    );

    return (
      <Row data-qa={k}>
        <Col xs={4}>
          <FormControl
            type="text"
            disabled={readOnly || hasOverride}
            name={k}
            onChange={this._onKeyChange}
            value={k}
          />
        </Col>
        <Col xs={8}>
          <FormInput
            inputButton={removeBtn}
            hasOverride={hasOverride}
            isRequired={false}
          >
            <FormControl
              type="text"
              disabled={readOnly || (hasOverride && !isOverriding)}
              name={v}
              onChange={this._onValChange}
              value={v}
            />
          </FormInput>
        </Col>
      </Row>
    );
  }
}

export { CustomParamField };
